import React from 'react'
import t from '~t'
import config from '~config'
import { target } from '~target'

import { Layout, Title, Button } from '~ui';

function Extension() {
    return (
        <Layout>
            <Title className={'ui-ext-center'}>{t.s('startToSave')}</Title>
            <div />

            <Button 
                href={new URL('/account/extension', config.links.app.index).href}
                target='_blank'
                variant='primary'
                data-block
                autoFocus>
                {t.s('signIn')}
            </Button>
        </Layout>
    )
}

function Web() {
    return (
        <div className={'ui-ext-page'}>
            <p>
                Click <b>Save extension</b> icon to get started
            </p>

            <Button 
                variant='outline'
                onClick={()=>window.close()}>
                {t.s('close')}
            </Button>
        </div>
    )
}

export default target == 'extension' ? Extension : Web